import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	PAYMENT_TYPE: '[data-fragment="OrderPayment.paymentType"]',
};

class OrderPayment extends WebComponent {
	constructor(props) {
		super(props);
		const {} = props;
	}

	didMount() {
		const {
		} = this.props;

		// Automatické zvolení widgetu pokud je pouze jedna možnost
		let paymentTypeOnlyOne = document.querySelectorAll(fragments.PAYMENT_TYPE);
		if (paymentTypeOnlyOne.length === 1) {
			paymentTypeOnlyOne[0].click();
		}

	}
}
export default OrderPayment;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/Orders/OrderPayment.js